export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 text-[#1A1A1A] leading-relaxed">
      <div className="text-xs uppercase tracking-[0.2em] text-[#C05A3D] font-semibold">Terms</div>
      <h1 className="font-display text-4xl text-[#1E3A2F] mt-1">Terms of Use</h1>
      <p className="text-sm text-[#5C5C5C] mt-2">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="space-y-5 mt-8">
        <p>By creating an account you agree to use African Bridge Media respectfully and lawfully. Below are the rules that keep our community welcoming.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Community standards</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>No hate speech, harassment or discrimination.</li>
          <li>No illegal, counterfeit, dangerous or prohibited goods.</li>
          <li>Be honest — describe items and events accurately.</li>
          <li>Respect intellectual property and privacy.</li>
        </ul>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Content ownership</h2>
        <p>You retain ownership of what you post; you grant African Bridge Media a license to display it on the platform.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Transactions</h2>
        <p>African Bridge Media is a listing platform — we don't process payments and are not a party to any transaction between members.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Enforcement</h2>
        <p>Violations may result in content removal or account suspension. Report violations to help keep the community safe.</p>
      </div>
    </div>
  );
}
